import { Avatar, Box, DialogTitle, Stack, Typography } from '@mui/material';
import { TYPE } from '@/theme/typography';
import { useAuthStore } from '@/stores/authStore';
import { resolveUploadUrl } from '@/utils/format';

interface BrandedDialogTitleProps {
  children: React.ReactNode;
}

/**
 * Drop-in replacement for MUI DialogTitle that shows the active company's
 * logo (or colour-coded initial) and name beneath the title text.
 *
 * Usage:
 *   <BrandedDialogTitle>Add New Employee</BrandedDialogTitle>
 */
export default function BrandedDialogTitle({ children }: BrandedDialogTitleProps) {
  const company = useAuthStore.getState().getActiveCompany();

  return (
    <DialogTitle sx={{ pb: 0 }}>
      <Stack direction="row" alignItems="center" spacing={1.5}>
        <Avatar
          src={resolveUploadUrl(company?.company_logo_url)}
          sx={{
            width: 36,
            height: 36,
            bgcolor: company?.company_colour || 'primary.main',
            fontSize: TYPE.sm,
            fontWeight: TYPE.bold,
          }}
        >
          {company?.company_name?.[0] || 'C'}
        </Avatar>
        <Box>
          <Typography sx={{ fontSize: TYPE.lg, fontWeight: TYPE.bold, lineHeight: 1.2 }}>
            {children}
          </Typography>
          <Typography sx={{ fontSize: TYPE.xs, color: 'text.secondary' }}>
            {company?.company_name}
          </Typography>
        </Box>
      </Stack>
    </DialogTitle>
  );
}
